import {createFileRoute} from '@tanstack/react-router';
import {Group, Stack, Text} from '@mantine/core';
import {IconFile, IconUpload, IconX} from '@tabler/icons-react';
import {useState} from 'react';
import {Dropzone} from '@mantine/dropzone';
import {useListPackages} from '@/features/deploymentManagement/api/packageQueries';
import {PackageTable} from '@/features/deploymentManagement/components/Packages/PackageTable';
import {PackageUploadModal} from '@/features/deploymentManagement/components/Packages/PackageUploadModal';
import {DeploymentLayout} from '@/features/deploymentManagement/components/DeploymentLayout';

export const Route = createFileRoute('/_authed/admin/deployment-center/packages/')({
    component: PackagesPage
});

function PackagesPage() {
    const [uploadModalOpened, setUploadModalOpened] = useState(false);
    const [preDroppedFile, setPreDroppedFile] = useState<File | null>(null);
    const {data: packagesResponse, isLoading, refetch} = useListPackages();

    const packages = packagesResponse?.packages || [];

    const handleDrop = (files: File[]) => {
        if (files.length > 0) {
            setPreDroppedFile(files[0]);
            setUploadModalOpened(true);
        }
    };

    const handleModalClose = () => {
        setUploadModalOpened(false);
        setPreDroppedFile(null);
    };

    return (
            <DeploymentLayout>
                <Stack gap="md">
                    <Dropzone
                            onDrop={handleDrop}
                            maxSize={500 * 1024 * 1024} // 500MB limit
                            accept={{
                                'application/x-msi': ['.msi']
                            }}
                            multiple={false}
                            aria-label="upload-package-dropzone"
                    >
                        <Group justify="center" gap="xl" mih={100} style={{pointerEvents: 'none'}}>
                            <Dropzone.Accept>
                                <IconUpload size={52} color="var(--mantine-color-blue-6)" stroke={1.5}/>
                            </Dropzone.Accept>
                            <Dropzone.Reject>
                                <IconX size={52} color="var(--mantine-color-red-6)" stroke={1.5}/>
                            </Dropzone.Reject>
                            <Dropzone.Idle>
                                <IconFile size={52} color="var(--mantine-color-dimmed)" stroke={1.5}/>
                            </Dropzone.Idle>

                            <div>
                                <Text size="xl" inline>
                                    Drop MSI files here or click to upload
                                </Text>
                                <Text size="sm" c="dimmed" inline mt={7}>
                                    Upload CadCare Connect Agent packages (max 500MB)
                                </Text>
                            </div>
                        </Group>
                    </Dropzone>

                    <PackageTable packages={packages}
                                  loading={isLoading}
                                  onRefresh={() => refetch()}
                    />

                    <PackageUploadModal
                            opened={uploadModalOpened}
                            onClose={handleModalClose}
                            preDroppedFile={preDroppedFile}
                    />
                </Stack>
            </DeploymentLayout>
    );
}